import React, { memo } from 'react';
import { useAppBrandContext } from '../../app-brand/app-brand-context-provider';

export const AppHeaderLogo = memo((): JSX.Element => {
  const { AppHeaderLogoSrc } = useAppBrandContext();

  return <img alt='ShipStation Logo' data-pendo-id='toolbar#logo' src={AppHeaderLogoSrc} />;
});

AppHeaderLogo.displayName = 'AppHeaderLogo';
